import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
//import JwtService from "@/core/services/jwt.service";
import config from '@/config/config'
import TokenService from "./tokenservice";
import { router } from "@/router";
import { gunzipSync, strFromU8 } from "fflate";

  function CallRefreshToken(){
    window.parent.postMessage("RequestRefreshToken", "*");
  }
/**
 * Service to call HTTP request via Axios
*/
const ApiService = {
  

  init() {
    // Fetch the config.json file
    Vue.use(VueAxios, axios);
    
    Vue.axios.defaults.baseURL = config.VUE_APP_BASE_API

      Vue.axios.interceptors.request.use(
        (config) => {
          const token = TokenService.getLocalAccessToken();
          if (token) {
            config.headers["Authorization"] = 'Bearer ' + token; 
            config.headers["x-access-token"] = token; 
  
          }
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    
      Vue.axios.interceptors.response.use(
        (response) => response,
        async (err) => {
          const originalConfig = err.config;
          if (originalConfig.url !== "/auth/signin" && err.response) {
            // Access Token was expired
             if (err.response.status === 401 && !originalConfig._retry) {
              originalConfig._retry = true;
                CallRefreshToken()
            }
          }
          return Promise.reject(err);
        }
      );
  },
   
  /**
   * Set the default HTTP request headers
   */
  setHeader() {
        // set userpayload as header
        const userPayload = Vue.prototype.$userPayload
        Vue.axios.defaults.headers.common["X-User-Payload"] = userPayload;
        Vue.axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;

  },
  setUserPayload() {
        // set userpayload as header
        const userPayload = Vue.prototype.$userPayload
        Vue.axios.defaults.headers.common["X-User-Payload"] = userPayload;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      // 
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch((error) => {
      // 
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  getData(resource) {
    return Vue.axios.get(`${resource}`).catch((error) => {
      // 
      throw new Error(`[KT] ApiService ${error}`);
    });
  },
  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params ?: any) {
    return Vue.axios.post(`${resource}`, params);
  },
postBlob(resource, params) {
  return Vue.axios.post(resource, params, { responseType: 'blob' });
},
  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch((error) => {
      // 
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
  newDelete(address, payload) {
    return Vue.axios.delete(address, {data: payload}).catch((error) => {
      // 
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
async postCompressed(resource, payload) {
  try {
    const response = await Vue.axios.post(resource, payload, {
      responseType: "arraybuffer" 
    });
    
    const decompressed = gunzipSync(new Uint8Array(response.data));
    const jsonStr = new TextDecoder().decode(decompressed);
    console.log("JSON.parse(jsonStr)",JSON.parse(jsonStr))
    return  JSON.parse(jsonStr) ;

  } catch (error) {
      throw new Error(`[RWV] ApiService ${error}`);
  }
},
};

export default ApiService;
